module.exports = __webpack_public_path__ + "img/star_active.1d5a48d9.svg";